<div class="login-container">
	<div class="header">Hold on, we are authenticating you...</div>
	<br />
	<div>
		<p-progressSpinner class="spinner" strokeWidth="4"></p-progressSpinner>
	</div>
</div>
